import React from 'react'
import { connect } from 'react-redux'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import LoadingIndicator from '@/components/LoadingIndicator'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import { InfoRow, InfoLabel, InfoContent } from '@/components/InfoRow'
import { Form, Row, Col, TabContent, TabPane } from 'reactstrap'
import { actionCreators } from '@/store/MyTickets'
import { BsrsGrid, EnumFilterCell, EnumCellStatus, commandColumnProps, DateCell, DateTimeCell, DateFilterCell, DateTimeFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import Icon from '@/components/Icon'
import { DataLoader } from '@/components/dataLoader'
import StepErrorCell from './stepErrorCell'
import createStepNameCell, { createStepNameFilterCell, excelStepNameCell } from './stepNameCell'
import { NotFound404 } from '@/components/404'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'
import { TabNavItems } from '@/components/tabs'
import Name from '@/components/Name'
import { NameColumn } from '@/components/BsrsGrid/index'
import { TicketInfo } from '@/internal-app/pages/tickets/ticketInfo'
import { TicketRestartedWarning } from '@/internal-app/pages/tickets/ticketRestartedWarning'

@localized()
class MyTicketDetail extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      activeTab: '1'
    }
    this.toggle = this.toggle.bind(this)
    this.workflowResumeHandler = this.workflowResumeHandler.bind(this)
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  componentWillMount () {
    this.props.getMyTicket(this.props.match.params.id)
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.getMyTicket(nextProps.match.params.id)
    }
  }

  workflowResumeHandler () {
    this.props.getMyTicket(this.props.match.params.id)
  }

  renderForm (ticket) {
    const { localize, locale } = this.props
    const enumName = 'TicketStatus'
    return (
      <React.Fragment key={ticket.id}>
        <MainTop>
          <MainTopTitle backUrl='/tickets'>
            <span className='ticket-label'><Icon name='list-alt' /> {ticket.id}</span>
            <span><Name data={{ name: ticket.name, latinName: ticket.latinName }} /></span>
          </MainTopTitle>
        </MainTop>

        <MainBody transparent>
          <TicketRestartedWarning restartedAsTicketId={ticket.restartedAsTicketId} />
          <Row>
            <Col lg='4'>
              <WhiteBox header='Tickets.Title'>
                <Form>
                  <InfoRow>
                    <InfoLabel size='sm'><Resx name='Common.Id' /></InfoLabel>
                    <InfoContent>{ticket.id}</InfoContent>
                  </InfoRow>
                  <TicketInfo ticket={ticket} workflowResumeHandler={this.workflowResumeHandler} workflowRestartHandler={this.workflowResumeHandler} />
                </Form>
              </WhiteBox>
            </Col>
            <Col lg='8' className='white-box-full-height'>
              <WhiteBox>
                <TabNavItems
                  activeTabId={this.state.activeTab}
                  onClick={tabId => this.toggle(tabId)}
                  items={[
                    { id: '1', text: localize('Tasks.TasksTitle') },
                    { id: '2', text: localize('Tickets.RelatedTickets') },
                    { id: '3', text: localize('Tickets.Log') }
                  ]} />
                <TabContent renderActiveOnly activeTab={this.state.activeTab}>

                  <TabPane tabId='1'>
                    <BsrsGrid className='' dataSource={(request) => context.api.taskService.getRelatedTasksTableData(ticket.id, request)} lastReloadedAt={ticket.id}>
                      <Column field='id' title={localize('Common.Id')} filter='numeric' width='150px' />
                      <Column field='assignedTo' title={localize('Tasks.AssignedTo')} />
                      <Column field={this.props.localizeProps()} title={localize('Tasks.Task')} />
                      <Column field='dueDate' title={localize('Tasks.DueDate')} filter='date' cell={DateCell} filterCell={DateFilterCell} />
                      <Column field='status' title={localize('Tasks.Status')}
                        cell={EnumCellStatus({ localize, enumName: workflowTaskStatus.enumName })}
                        filterCell={EnumFilterCell({ localize, enumName: workflowTaskStatus.enumName }, [0, 1, 2])} enumName={workflowTaskStatus.enumName} />
                      <Column {...commandColumnProps({ detailUrl: x => x.canSeeDetail ? `/tasks/${x.id}` : '' })} />
                    </BsrsGrid>
                  </TabPane>
                  <TabPane tabId='2'>
                    <BsrsGrid className='' dataSource={(request) => context.api.ticketService.getRelatedTicketsTableData(ticket.rootTicketId || ticket.id, relatedTicketFilter(ticket.id, request))} lastReloadedAt={ticket.id}>
                      <Column field='id' title={localize('Common.Id')} filter='numeric' width='150px' />
                      <Column field='ticketType' title={localize('Common.Type')} />
                      {NameColumn({ locale, title: localize('Common.Name'), editable: false })}
                      <Column field='author' title={localize('Common.Author')} />
                      <Column field='creationTime' title={localize('Common.CreationTime')} filter='date' cell={DateCell} filterCell={DateFilterCell} />
                      <Column field='status' title={localize('Common.Status')}
                        cell={EnumCellStatus({ localize, enumName, visualStatus: [0, 1, 2, 3, 3] })}
                        filterCell={EnumFilterCell({ localize, enumName }, [0, 1, 2, 3, 4])} />
                      <Column {...commandColumnProps({ detailUrl: x => x.canSeeDetail ? `/tickets/${x.id}` : '' })} />
                    </BsrsGrid>
                  </TabPane>
                  <TabPane tabId='3'>
                    <DataLoader dataSource={() => context.api.ticketService.getStepNames(ticket.id)} render={x =>
                      x.loading ? <LoadingIndicator />
                        : <BsrsGrid
                          dataSource={(request) => context.api.ticketService.getWorkflowPointers(ticket.id, request)}
                          sortable={false} lastReloadedAt={ticket.id} defaultSort={[{ field: 'startTime', dir: 'asc' }]}>
                          <Column field='stepId' title={localize('Tickets.Step')} width='250px'
                            cell={createStepNameCell(x.data)}
                            filterCell={createStepNameFilterCell(x.data, localize)} cellExport={excelStepNameCell} cellExportProps={{ stepNames: x.data }} />
                          <Column field='startTime' title={localize('Tickets.StepStartTime')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} />
                          <Column field='endTime' title={localize('Tickets.StepEndTime')} filter='date' cell={DateTimeCell} filterCell={DateTimeFilterCell} />
                          <Column field='errorCount' filter='numeric' title={localize('Tickets.StepErrors')} cell={StepErrorCell} />
                          <Column field='status' title={localize('Common.Status')}
                            cell={EnumCellStatus({ localize, enumName: 'WorkflowPointerStatus', visualStatus: v => v === 3 ? 2 : (v === 2 ? 1 : (v > 5 ? 3 : 0)) })}
                            filterCell={EnumFilterCell({ localize, enumName: 'WorkflowPointerStatus' }, [0, 1, 2, 3, 4, 5, 6, 7])} enumName='WorkflowPointerStatus' />
                        </BsrsGrid>}
                    />
                  </TabPane>
                </TabContent>
              </WhiteBox>
            </Col>
          </Row>
        </MainBody>
      </React.Fragment>
    )
  }
  render () {
    const { myTickets } = this.props
    if (!myTickets.fetching && !myTickets.ticket) {
      return <NotFound404 />
    }
    const showLoadingIndicator = myTickets.fetching || Number(this.props.match.params.id) !== myTickets.ticket.id
    return (
      <Main>
        {showLoadingIndicator ? <LoadingIndicator /> : this.renderForm(myTickets.ticket)}
      </Main>
    )
  }
}

function relatedTicketFilter (ticketId, request) {
  if (!request.filter) {
    request.filter = { logic: 'and', filters: [] }
  }
  request.filter.filters.push({ field: 'id', operator: 'neq', value: ticketId })
  return request
}

const mapStateToProps = (state, ownProps) => {
  return {
    myTickets: state.myTickets,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getMyTicket: actionCreators.get
}

export default connect(mapStateToProps, mapDispatchToProps)(MyTicketDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/detail.js